// Persistencia temporal de la sesion para el retorno de la pasarela de pago.
//
// La pasarela (Centro de Pagos) redirige la VENTANA COMPLETA a urlRetorno tras
// "Finalizar". Eso recarga la app de NuevoIngreso y se pierde el estado de React
// (Credenciales, admision, invoice). Para poder validar el pago, aprobar la
// admision y mostrar el modal de exito (img4) al volver, se guardan aqui los
// datos minimos ANTES de abrir la pasarela y se rehidratan al recargar.
//
// SEGURIDAD: se guarda informacion de sesion (incluido el token) en
// localStorage, expuesta a XSS. Por eso el item se BORRA en cuanto se consume
// (un solo uso) y solo vive el tiempo del redirect de la pasarela.

const CLAVE_PAGO_RETORNO = "pagoRetornoNuevoIngreso";

// Marca en la URL de retorno que indica que venimos de la pasarela.
export const PARAM_PAGO_RETORNO = "pagoRetorno";

/**
 * Guarda los datos necesarios para reconstruir el flujo al volver de la pasarela.
 * @param {{ credenciales:object, admisionId:string, invoiceId:string }} datos
 */
export const guardarPagoRetorno = (datos) => {
  try {
    window.localStorage.setItem(CLAVE_PAGO_RETORNO, JSON.stringify(datos));
  } catch (e) {
    // localStorage no disponible / lleno: el retorno caera al flujo manual.
  }
};

/**
 * Lee los datos del retorno de pago (o null si no hay).
 * @returns {{ credenciales:object, admisionId:string, invoiceId:string }|null}
 */
export const obtenerPagoRetorno = () => {
  try {
    const crudo = window.localStorage.getItem(CLAVE_PAGO_RETORNO);
    return crudo ? JSON.parse(crudo) : null;
  } catch (e) {
    return null;
  }
};

/** Borra los datos del retorno de pago (uso unico). */
export const limpiarPagoRetorno = () => {
  try {
    window.localStorage.removeItem(CLAVE_PAGO_RETORNO);
  } catch (e) {
    // sin accion
  }
};

/** True si la URL actual trae la marca de retorno de la pasarela. */
export const esRetornoPago = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get(PARAM_PAGO_RETORNO) === "1";
  } catch (e) {
    return false;
  }
};

/**
 * Quita la marca de retorno de la URL sin recargar, para que un refresh
 * posterior no vuelva a disparar el flujo de retorno.
 */
export const limpiarParamRetornoUrl = () => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete(PARAM_PAGO_RETORNO);
    window.history.replaceState({}, document.title, url.pathname + url.search);
  } catch (e) {
    // sin accion
  }
};
